
import { default as Moment } from 'moment';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useNavigate } from "react-router-dom";
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import view_apartment_type_ar from "../../functions/view_apartment_type";
import '../../Helper/links.js';
import { _endPoints, baseUrl } from "../../Helper/links.js";
import API from "../../Helper/server/API.js";
import img_table_beach from '../../public/images/table_beach.png';
import img_waterpark from '../../public/images/waterpark_2.png';
import { View_service_img } from '../../constants/dataView';

let today = new Date();
export let booking_apartments_dates = {};
function BookingServiceSelectedStep({ onDataChange }) {
    const toast = useRef(null);
    const items = Array.from({ length: 5 }, (v, i) => i);
    const [loading_render, set_loading_render] = useState(true);
    // addLocale('en', {
    //   firstDayOfWeek: 1,
    //   dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    //   dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    //   dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    //   monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']    ,
    //   monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    //   today: 'Today',
    //   clear: 'Clear'
    // });
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const Navigate = useNavigate();
    //_______________________________________________________
    const [services, setServices] = useState([]);
    const [dates, setDates] = useState([]);
    //_______________________________________________________
    //                      Dates Apartments
    //_______________________________________________________
    function dates_close(dates_reservationes) {
        if (!dates_reservationes) return [];
        var dates_disabled = [];
        // eslint-disable-next-line array-callback-return
        dates_reservationes.map((date) => {
            var date_in = new Date(date.date_check_in);
            var date_out = new Date(date.date_check_out);
            while (Moment(date_in).format("yyyy-MM-DD") <= Moment(date_out).format("yyyy-MM-DD")) {
                dates_disabled.push(new Date(Moment(date_in).format("yyyy-MM-DD")));
                date_in.setDate(date_in.getDate() + 1);
            }
        })
        return dates_disabled;
    }
    function dateTemplate(date, dates_reservationes) {
        if (!dates_reservationes) return <span style={{ color: "black" }}>{date.day}</span>;
        var IsAvailable = true;
        for (var i = 0; i < dates_reservationes.length; i++) {
            if (
                Moment(date).format("yyyy-MM-DD") >= Moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD")
                &&
                Moment(date).format("yyyy-MM-DD") <= Moment(dates_reservationes[i].date_check_out).format("yyyy-MM-DD")
            ) {
                IsAvailable = false;
                break;
            }
        }
        if (!IsAvailable) {
            return (
                <span className="strikethrough-red" >{date.day}</span>
            );
        }
        else {
            return (
                <span style={{ color: "black" }}>{date.day}</span>
            );
        }
    }
    const handelDates = (e, id_service) => {
        setDates(e.target.value);
        booking_apartments_dates[id_service] = e.target.value;
        onDataChange({
            id_service: id_service,
            dates: e.target.value
        })


    }
    const clear_days = async (e, id_service) => {
        setDates([])
        booking_apartments_dates[id_service] = [];
        onDataChange({
            id_service: id_service,
            dates: []
        })
    }

    const [selectedServiceId, setSelectedServiceId] = useState(null);
    //_______________________________________________________________________________________
    //                      Get Services
    const GetServices = async () => {
        set_loading_render(true)
        const response = await API.get(_endPoints.reservations.services.get_all)
        if (response?.success === 1) {
            setServices(response.data);
        }
        else if (response?.success === 0 || response?.errors == 1) {
            toast?.current?.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loading_render(false)

    }

    const handleServiceSelect = (item) => {
        setIsSelected(item)
        // Clear all other dates in booking_apartments_dates
        Object.keys(booking_apartments_dates).forEach(id => {
            if (id != item.ID_service) {
                booking_apartments_dates[id] = [];
            }
        });

        setSelectedServiceId(item.ID_service);

        // Notify parent with the change (clearing others)
        onDataChange(item);
    };

    useEffect(() => {
        booking_apartments_dates = []
        GetServices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(9);

    const [isSelected, setIsSelected] = useState(null);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    return (
        <div className="service-selection-container">
            <style>{`
                .service-selection-container {
                    padding: 30px;
                    background: #f8fafc;
                    min-height: 100%;
                }
                .service-card {
                    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
                    cursor: pointer;
                    border: 2px solid transparent;
                    border-radius: 20px;
                    overflow: hidden;
                    background: rgba(255, 255, 255, 0.8);
                    backdrop-filter: blur(8px);
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
                    height: 100%;
                    position: relative;
                    margin-bottom: 30px;
                    display: flex;
                    flex-direction: column;
                }
                .service-card:hover {
                    transform: translateY(-12px) scale(1.02);
                    box-shadow: 0 30px 60px -12px rgba(50, 50, 93, 0.25), 0 18px 36px -18px rgba(0, 0, 0, 0.3);
                }
                .service-card.selected {
                    border-color: #2196F3;
                    background: #ffffff;
                    box-shadow: 0 20px 40px rgba(33, 150, 243, 0.15);
                }
                .service-card.selected::before {
                    content: '\\e909';
                    font-family: 'primeicons';
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
                    color: white;
                    width: 36px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 12px;
                    z-index: 10;
                    font-size: 18px;
                    box-shadow: 0 8px 16px rgba(33, 150, 243, 0.3);
                    animation: bounceIn 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
                }
                @keyframes bounceIn {
                    0% { transform: scale(0); opacity: 0; }
                    70% { transform: scale(1.2); }
                    100% { transform: scale(1); opacity: 1; }
                }
                .service-img-container {
                    padding: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 250px;
                    background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
                    position: relative;
                }
                .service-img {
                    max-width: 85%;
                    max-height: 85%;
                    object-fit: contain;
                    filter: drop-shadow(0 10px 15px rgba(0,0,0,0.1));
                    transition: all 0.6s ease;
                }
                .service-card:hover .service-img {
                    transform: scale(1.15) translateY(-5px);
                    filter: drop-shadow(0 20px 30px rgba(0,0,0,0.2));
                }
                .service-body {
                    padding: 30px;
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                }
                .service-title {
                    font-weight: 800;
                    font-size: 1.5rem;
                    margin-bottom: 12px;
                    color: #0f172a;
                    letter-spacing: -0.02em;
                }
                .service-info {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 20px;
                    margin-top: auto;
                    border-top: 1px solid #f1f5f9;
                }
                .service-capacity {
                    background: #f1f5f9;
                    color: #475569;
                    padding: 6px 14px;
                    border-radius: 10px;
                    font-size: 0.9rem;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                }
                .service-price {
                    font-weight: 900;
                    color: #2196F3;
                    font-size: 1.6rem;
                    text-shadow: 0 2px 4px rgba(33, 150, 243, 0.1);
                }
                .service-badge {
                    background: #dcfce7;
                    color: #166534;
                    padding: 6px 16px;
                    border-radius: 12px;
                    font-size: 0.8rem;
                    font-weight: 800;
                    margin-bottom: 15px;
                    align-self: center;
                    box-shadow: 0 4px 10px rgba(22, 101, 52, 0.1);
                }

                .custom-mini-calendar {
                    border: none !important;
                    background: transparent !important;
                }
                .custom-mini-calendar .p-datepicker {
                    border: none !important;
                    box-shadow: none !important;
                    background: transparent !important;
                    padding: 0 !important;
                }
                .animated {
                    animation-duration: 0.5s;
                    animation-fill-mode: both;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .fadeIn { animation-name: fadeIn; }
            `}</style>

            <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />

            <div dir="rtl">
                {loading_render ? (
                    <div className="row">
                        {[1, 2, 3].map(i => (
                            <div className="col-md-4 mb-4" key={i}>
                                <Skeleton width="100%" height="400px" ></Skeleton>
                            </div>
                        ))}
                    </div>
                ) : (
                    <>
                        <div className="row">
                            {services.map((service, index) => (
                                <div className="col-md-4 mb-4" key={`_${index}_${service?.ID_service}`}>
                                    <div
                                        className={`service-card ${isSelected?.ID_service === service?.ID_service ? 'selected' : ''}`}
                                        onClick={() => handleServiceSelect(service)}
                                        key={`_${index}_${service?.ID_service}`}
                                    >
                                        <div className="service-img-container">
                                            <img src={View_service_img(service)} className="service-img" alt={'test'} />
                                        </div>
                                        <div className="service-body">
                                            <span className="service-badge">خـدمة مـميزة</span>
                                            <h4 className="service-title">{service.service_name_ar}</h4>
                                            <div className="service-info">
                                                <div className="service-capacity">
                                                    <i className="pi pi-users ml-2 text-primary"></i>
                                                    {service.max_persons} أشخاص
                                                </div>
                                                <div className="service-price">
                                                    {service.price} د.ل
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default BookingServiceSelectedStep;


